import { useCallback, useEffect, useState } from 'react';

import { isClient } from 'utils';

/**
 * One-time onboarding tooltip: opens once the anchor is available and is never shown
 * again — the flag is written the moment it opens, so a reload counts as "seen".
 * Runs after mount only: SSR and the hydration render always see it closed.
 */
export function useOneTimeTooltip(storageKey: string, isAvailable: boolean) {
  const [isTooltipOpen, setIsTooltipOpen] = useState(false);

  useEffect(() => {
    if (!isAvailable || !isClient) {
      return;
    }

    try {
      if (window.localStorage.getItem(storageKey)) {
        return;
      }

      window.localStorage.setItem(storageKey, '1');
    } catch {
      // Storage may be unavailable (private mode, blocked site data): the hint is
      // harmless to repeat, so fall through and show it.
    }

    setIsTooltipOpen(true);
  }, [storageKey, isAvailable]);

  const closeTooltip = useCallback(() => setIsTooltipOpen(false), []);

  return { isTooltipOpen, closeTooltip };
}
